const actionTypes = {
  REGISTER_INTERRUPTION: '@WS/INTERRUPTER/REGISTER_INTERRUPTION',
  REGISTER_INTERRUPTION_POINT: '@WS/INTERRUPTER/REGISTER_INTERRUPTION_POINT',
  BLOCK: '@WS/INTERRUPTER/BLOCK',
  UNBLOCK: '@WS/INTERRUPTER/UNBLOCK',
};

export default actionTypes;
